const createSocket = (task_id) => {
    return new WebSocket(`${process.env.REACT_APP_BASE_WEBSOCKET_URL}${task_id}/`)
}

export default createSocket;